/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Form_Start_PhInputs */

const en_cp_form_start_ph = /** @type {(inputs: Cp_Form_Start_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Fall 2026/2027`)
};

const id_cp_form_start_ph = /** @type {(inputs: Cp_Form_Start_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`mis. Ganjil 2026/2027`)
};

/**
* | output |
* | --- |
* | "e.g. Fall 2026/2027" |
*
* @param {Cp_Form_Start_PhInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_form_start_ph = /** @type {((inputs?: Cp_Form_Start_PhInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Form_Start_PhInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_form_start_ph(inputs)
	return en_cp_form_start_ph(inputs)
});